<tt-form-field-base
    [ttRememberId]="ttRememberId"
    [ttRememberDebounceTime]="ttRememberDebounceTime"
    [ttFieldId]="id"
    [ttLabel]="ttLabel"
    [ttLabelView]="ttLabelView"
    [ttTranslateLabel]="ttTranslateLabel"
    [ttSublabel]="ttSublabel"
    [ttTranslateSublabel]="ttTranslateSublabel"
    [ttToggleTipText]="ttToggleTipText"
    [ttTranslateToggleTipText]="ttTranslateToggleTipText"
    [ttInvalid]="ttInvalid"
    [ttInvalidText]="ttInvalidText"
    [ttTranslateInvalidText]="ttTranslateInvalidText"
    [ttRequired]="ttRequired"
    [ttReadonly]="ttReadonly"
    [ttDisabled]="ttDisabled"
    [ttStyle]="ttStyle"
    ttInputType="input"
>
    <span class="tt-search-multi-select__inputs" [ngClass]="{ 'tt-search-multi-select__inputs--focused': chipInput.focused }">
        <mat-chip-grid #chips class="tt-search-multi-select__mat-chip-grid">
            <ng-container *ngIf="ttModelSetting !== 'object'">
                <mat-chip-row *ngFor="let id of selectedIds" class="tt-search-multi-select__mat-chip-row" [attr.title]="id" [removable]="!ttReadonly && !ttDisabled" (removed)="remove(id)">
                    <span class="tt-search-multi-select__chip-label">{{ id }}</span>
                    <button *ngIf="!ttReadonly && !ttDisabled" matChipRemove class="tt-search-multi-select__remove" [attr.aria-label]="'remove ' + id">
                        <span class="far fa-times"></span>
                    </button>
                </mat-chip-row>
            </ng-container>
            <ng-container *ngIf="ttModelSetting === 'object'">
                <mat-chip-row
                    *ngFor="let item of selectedItems"
                    class="tt-search-multi-select__mat-chip-row"
                    [attr.title]="item[ttDataName]"
                    [removable]="!ttReadonly && !ttDisabled"
                    (removed)="remove('' + item[ttDataId])"
                >
                    <span class="tt-search-multi-select__chip-label">{{ item[ttDataName] }}</span>
                    <button *ngIf="!ttReadonly && !ttDisabled" matChipRemove class="tt-search-multi-select__remove" [attr.aria-label]="'remove ' + item[ttDataId]">
                        <span class="far fa-times"></span>
                    </button>
                </mat-chip-row>
            </ng-container>
        </mat-chip-grid>
        <span class="tt-search-multi-select__input-row flex-1" style="display: flex; flex-wrap: nowrap; height: 100%">
            <input
                class="tt-search-multi-select__input"
                #inputRef
                #chipInput="matChipInput"
                [formControl]="searchtext"
                [matChipInputFor]="chips"
                [matAutocomplete]="auto"
                [matAutocompleteConnectedTo]="origin"
                (matChipInputTokenEnd)="add($event)"
                [readOnly]="ttReadonly"
                (focusout)="onBlur(auto)"
            />
            <span class="tt-search-multi-select__autocomplete-origin" matAutocompleteOrigin #origin="matAutocompleteOrigin"></span>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" hideSingleSelectionIndicator autoActiveFirstOption multiple>
                <mat-option *ngFor="let item of data | async; trackBy: trackItem" [id]="id + item[this.ttDataId]" class="tt-listbox__item" [value]="item">
                    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
                    <!-- <span>
                        <span *ngIf="!!item[this.ttDataIcon]" class="fad fa-fw" [ngClass]="'' + item[this.ttDataIcon]"></span>
                        {{ item[ttDataName] }}
                    </span>
                    <span *ngIf="selectedIds.includes('' + item[this.ttDataId])" class="far fa-check"></span> -->
                </mat-option>
            </mat-autocomplete>
            <ng-container buttons>
                <tt-form-field-button
                    *ngIf="ttShowClearButton && !ttReadonly && !ttDisabled"
                    ttId="$clear"
                    ttIcon="fas fa-eraser"
                    ttTooltip="remove_all_selected"
                    [ttTranslateTooltip]="true"
                    ttType="danger"
                    (ttClick)="clearInput()"
                ></tt-form-field-button>
                <tt-form-field-buttons *ngIf="ttButtons" buttons class="tt-search-mutli-select__buttons" [ttButtons]="ttButtons" [ttButtonParms]="ttButtonParms"></tt-form-field-buttons>
                <ng-content select="[buttons]"></ng-content>
            </ng-container>
        </span>
    </span>
</tt-form-field-base>

<ng-template #defaultItemTemplate let-item>
    <span>
        <span *ngIf="!!item[this.ttDataIcon]" class="fad fa-fw" [ngClass]="'' + item[this.ttDataIcon]"></span>
        {{ item[ttDataName] }}
    </span>
    <span *ngIf="selectedIds.includes('' + item[this.ttDataId])" class="far fa-check"></span>
</ng-template>
